import { IFlowManager, IFlowCore, IFlowSubscriber } from '.'

export class FlowManager implements IFlowManager {
  private _cores: IFlowCore[] = []

  public getCore(flowGroup: string): IFlowCore | undefined {
    for (let i = 0; i < this._cores.length; i++) {
      if (this._cores[i].flowGroup === flowGroup) {
        return this._cores[i]
      }
    }
    return undefined
  }

  public putCore(core: IFlowCore): void {
    let sameCoreIsInserted = false

    for (let i = 0; i < this._cores.length; i++) {
      const currentCore = this._cores[i]

      if (currentCore === core) {
        sameCoreIsInserted = true
        break
      }
    }

    if (!sameCoreIsInserted) {
      this._cores.push(core)
    }
  }

  public removeCore(core: IFlowCore): void {
    let indexOfCore = this._cores.indexOf(core)

    if (indexOfCore > -1) {
      this._cores.splice(indexOfCore, 1)
    }
  }

  public subscribe(subscriber: IFlowSubscriber): void {
    let core = this.getCore(subscriber.flowGroup || '')

    if (core) {
      core.subscribe(subscriber)
    }
  }

  public unsubscribe(subscriber: IFlowSubscriber): void {
    let core = this.getCore(subscriber.flowGroup || '')

    if (core) {
      core.unsubscribe(subscriber)
    }
  }
}
